import React, { useContext } from 'react';
import { Modal } from 'antd';
import TableForm from './TableForm';
import StoreConversionContext from '../../../contexts/store-conversion-context/StoreConversionProvider';
import { useTranslation } from 'react-i18next';

const SettingsWorkPlaceModal = () => {
  const {
    modalOpened,
    setModalOpened,
    setSelectedConversion,
    selectedConversion
  } = useContext(StoreConversionContext);
  const { t } = useTranslation();
  return (
    <Modal
      transitionName=""
      className="shared-custom-modal"
      width="90%"
      style={{ maxWidth: '742px' }}
      title={
        selectedConversion
          ? t('Inventory.TransferStocks.modifyTransformation')
          : t('Inventory.TransferStocks.addNewTransformation')
      }
      visible={modalOpened}
      onOk={() => {
        setModalOpened(false);
        setSelectedConversion(null);
      }}
      onCancel={() => {
        setModalOpened(false);
        setSelectedConversion(null);
      }}
      footer={false}
    >
      <TableForm />
    </Modal>
  );
};

export default SettingsWorkPlaceModal;
